import React from 'react';
import {useOutletContext} from 'react-router-dom';
import ClothingAiProfileTab from '../components/ClothingAiProfileTab';
import ItemBestMatches from '../components/ItemBestMatches';
import ItemCompatibilityAttributes from '../components/ItemCompatibilityAttributes';
import ItemReanalysisPanel from '../components/ItemReanalysisPanel';
import {hasPermission, useWardrobe} from '../context/WardrobeContext';
import type {ItemPageContext} from './ClothingItemDetail';

const ItemAiTab: React.FC = () => {
    const {item, itemId, refreshItem, selectedOwnerId, builderSlot} = useOutletContext<ItemPageContext>();
    const {isOwnWardrobe, permissions} = useWardrobe();
    // Права для CTA по совету (ai-advice-ladder); UI-скрытие поверх серверного enforcement.
    // AI-анализ вещи вне активного гардероба не запускается (retired-item-actions-guard):
    // сохранённый профиль читается, кнопка перегенерации скрыта.
    const isFrozen = !!item.inTrashBin || !!item.thrownAway;
    const canEdit = (isOwnWardrobe || hasPermission(permissions, 'EDIT_ITEMS')) && !isFrozen;
    const canMoveToTrash = isOwnWardrobe || hasPermission(permissions, 'MOVE_TO_TRASH');

    return (
        <div className="space-y-6">
            <ClothingAiProfileTab
                itemId={itemId}
                conditionName={item.conditionName}
                defectNames={item.defectNames}
                lifecycleStatus={item.lifecycleStatus}
                thrownAway={item.thrownAway}
                inTrashBin={item.inTrashBin}
                canEdit={canEdit}
                canMoveToTrash={canMoveToTrash}
                onItemChanged={refreshItem}
                visualProfile={item.visualProfile ?? null}
            />
            {/* item-reanalysis-dialog (FR-1): повторный ИИ-анализ вещи — только под EDIT_ITEMS
                и только для вещи в активном гардеробе (retired-item-actions-guard). */}
            {canEdit && (
                <ItemReanalysisPanel
                    itemId={itemId}
                    itemPhotos={item.photoUrls ?? []}
                    isOwnWardrobe={isOwnWardrobe}
                    onItemChanged={refreshItem}
                />
            )}
            {/* item-attribute-vector (FR-5): числовой вектор вещи из детальной карточки. */}
            <ItemCompatibilityAttributes profile={item.visualProfile ?? null}/>
            {/* CTHS-135 AC-3: лучшие сочетания из персистированного графа связей. Для вещи в
                корзине и выбывшей блок остаётся справочным — собирать из неё образ нельзя. */}
            <ItemBestMatches
                itemId={itemId}
                ownerId={selectedOwnerId}
                anchorSlot={builderSlot}
                anchorName={item.name}
                anchorBrandName={item.brandName}
                anchorPhotoUrl={item.photoUrls?.[0] ?? null}
                anchorCategoryId={item.categoryId}
                frozen={isFrozen}
            />
        </div>
    );
};

export default ItemAiTab;
